import { useState } from "react";
import { FAQS } from "../data/content";

export default function Faq() {
  const [open, setOpen] = useState(null);

  return (
    <div className="faq-sec">
      <div style={{ textAlign: "center", maxWidth: 480, margin: "0 auto" }}>
        <div className="eyebrow">FAQ</div>
        <h2 className="sec-title">Common <em>questions</em></h2>
      </div>

      <div className="faq-grid">
        {FAQS.map((item, i) => (
          <div className={`fi${open === i ? " open" : ""}`} key={i}>
            <div className="fi-q" onClick={() => setOpen(open === i ? null : i)}>
              <span>{item.q}</span>
              <div className="fi-ico">+</div>
            </div>
            <div className="fi-a">{item.a}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
